import React, { SyntheticEvent, useState } from 'react';

import { Helmet } from 'react-helmet';

import { Box, Container, Tab, Tabs } from '@mui/material';

import PageHeader from '../Common/Elements/PageHeader';

import Preferences from './Preferences';
import TripPlannerActivityLocation from './TripPlannerActivityLocation';
import TripPlannerContent from './TripPlannerContent';
import TripPlannerGenerateTripsFromCart from './TripPlannerGenerateTripsFromCart';
import TripPlannerImagesForSuggestedPlaces from './TripPlannerImagesForSuggestedPlaces';

export const contentTabs = {
  'Trip Planner': {
    title: 'Trip Planner',
    component: TripPlannerContent,
  },
  Preferences: {
    title: 'Preferences',
    component: Preferences,
  },
  Location: {
    title: 'Location',
    component: TripPlannerActivityLocation,
  },
  'Generate Trips from Cart': {
    title: 'Generate Trips from Cart',
    component: TripPlannerGenerateTripsFromCart,
  },
  'Images for suggested places': {
    title: 'Images for suggested places',
    component: TripPlannerImagesForSuggestedPlaces,
  },
} as const;

export const contentTabsList = Object.keys(contentTabs);

export type TripPlannerTab = keyof typeof contentTabs;

function TripPlannerPage() {
  const [currentTab, setCurrentTab] = useState<TripPlannerTab>('Trip Planner');

  const handleTabChange = (_event: SyntheticEvent, newValue: TripPlannerTab) => {
    setCurrentTab(newValue);
  };

  const CurrentTabComponent = contentTabs[currentTab].component;

  return (
    <Container maxWidth="lg">
      <Helmet>
        <title>TripPlanner - {contentTabs[currentTab].title}</title>
      </Helmet>
      <PageHeader title={`TripPlanner - ${contentTabs[currentTab].title}`} />

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={currentTab} onChange={handleTabChange}>
          {contentTabsList.map((tab) => (
            <Tab key={tab} value={tab} label={contentTabs[tab].title} />
          ))}
        </Tabs>
      </Box>

      <CurrentTabComponent />
    </Container>
  );
}

export default TripPlannerPage;
